// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","categoryMenu":"_2EJHvkxfnZZdvLLv","categoryItem":"_3LT7nvoJGm6wq0ZB","selectedCategory":"_252Uw2fE1jqtukUl","categoryTab":"_2a83y12bWF3SSB5t"};